import {
    Grid2
} from '@mui/material';
import { getActualStatus } from '../../_helpers/auction.helper';
import { AuctionCatalogueItemAdminUserBid } from './components/auction-catalogueItemAdminUserBid';
import { CatalogueItemStatusCard } from './components/auction-catalogueItemStatusCard';
import { AuctionCatalogueItemView } from './components/auction-catalogueItemView';
import { AuctionCatalogueList } from './components/auction-catalogueList';
import { AuctionMessages } from './components/auction-messages';
import { Dispatch, SetStateAction } from 'react';

export function AuctionProxyBidderIndex(params: {
    auction: any,
    catalogueItem: any,
    catalogueItemLoading: boolean,
    setProxyBidderId?: Dispatch<SetStateAction<string>>,
    proxyBidderId?: string
}) {

    return (
        <>
            <Grid2 size={{ xs: 12, md: 4 }}>
                <Grid2 container spacing={1}>

                    <Grid2 size={{ xs: 12 }}>
                        <AuctionCatalogueList proxyBidderId={params.proxyBidderId} auction={params.auction} catalogueItem={params.catalogueItem} actualAuctionStatusId={getActualStatus(params.auction, params.catalogueItem)} />
                    </Grid2>

                    <Grid2 size={{ xs: 12 }}>
                        <AuctionMessages catalogueId={params.catalogueItem?.catalogueId} />
                    </Grid2>

                </Grid2>
            </Grid2>

            <Grid2 size={{ xs: 12, md: 8 }}>
                <Grid2 container spacing={1}>

                    <Grid2 size={{ xs: 12 }}>
                        <CatalogueItemStatusCard catalogueItem={params.catalogueItem} actualAuctionStatusId={getActualStatus(params.auction, params.catalogueItem)} />
                    </Grid2>

                    <Grid2 size={{ xs: 12 }}>
                        <AuctionCatalogueItemView catalogueItem={params.catalogueItem} catalogueItemLoading={params.catalogueItemLoading} />
                    </Grid2>

                    <Grid2 size={{ xs: 12 }}>
                        <AuctionCatalogueItemAdminUserBid
                            catalogueItem={params.catalogueItem}
                            auctionId={params.auction?.id}
                            actualAuctionStatusId={getActualStatus(params.auction, params.catalogueItem)}
                            catalogueItemLoading={params.catalogueItemLoading}
                            setProxyBidderId={params.setProxyBidderId}
                        />
                    </Grid2>
                </Grid2>
            </Grid2>
        </>
    );
}
